export default __webpack_public_path__ + "static/media/cheragh.d09c05c2.png";